import compose from 'lodash/flowRight'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { withAnalytics } from 'modals/OrderList/DownloadOrderModal/DownloadOrderModal.analytics'

import DownloadOrderModal from './DownloadOrderModal.component'

export default compose(
  withRouterCustom,
  withMixpanel,
  withAnalytics,
)(DownloadOrderModal)
